import React, { FC } from 'react';
import { StyledToggleButton } from './ToggleButton.styles';

export type ToggleButtonProps = {
  children: JSX.Element | string;
  tagName?: undefined;
  type?: 'button' | 'submit' | 'reset' | undefined;
  inverted?: boolean;
  isSelected: boolean;
  isDisabled?: boolean;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  isLeftAligned?: boolean;
  testId?: string;
  selectedText?: JSX.Element | string;
  isSmall?: boolean;
  setWidth?: number;
  isDisplayed?: boolean;
};

export const ToggleButton: FC<ToggleButtonProps> = ({
  children,
  tagName = undefined,
  onClick = undefined,
  inverted = false,
  isSelected = false,
  type = undefined,
  isLeftAligned = false,
  isDisabled = false,
  testId,
  selectedText,
  isSmall,
  setWidth,
  isDisplayed = true,
}) => (
  <StyledToggleButton
    as={tagName}
    onClick={onClick}
    type={type}
    inverted={inverted}
    isSelected={isSelected}
    isLeftAligned={isLeftAligned}
    disabled={isDisabled}
    data-testid={testId}
    isSmall={isSmall}
    setWidth={setWidth}
    isDisplayed={isDisplayed}
  >
    {isSelected && selectedText ? selectedText : children}
  </StyledToggleButton>
);
